module.exports = __webpack_public_path__ + "static/img/06.cbcec07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/06.jpg
// module id = BOsz
// module chunks = 0